import styled from "styled-components";
import { SPACING } from "../../../utils/constants";

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs + SPACING.xxs}px;
  padding: ${SPACING.xs}px ${SPACING.sm + SPACING.xs}px;
  border-radius: 20px;
  font-size: var(--text-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;

  &.active {
    background: var(--color-success-background);
    color: var(--color-success);
    border: 1px solid var(--color-success-border);
  }

  &.inactive {
    background: var(--color-warning-background);
    color: var(--color-warning);
    border: 1px solid var(--color-warning-border);
  }

  &.closed {
    background: var(--color-error-background);
    color: var(--color-error);
    border: 1px solid var(--color-error-border);
  }

  .status-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--text-base);
    line-height: 0;
  }
`;
